import { ToastMessage } from '@cokitchen/cokitchen-components';
import EditReviewFooter from 'components/kitchen/edit-review/footer';
import EditReviewHeader from 'components/kitchen/edit-review/header';
import EditKitchenShiftCard from 'components/kitchen/shift-card/edit-kitchen-shift-card';
import useWeeklyRosterContext from 'contexts/weekly-roster.context';
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';
import { WEEKLY_ROSTER_PAGES } from 'utils/enum';
import { transformShifts } from '../weekly-roster/utils';

const shifts = ['morning', 'afternoon', 'night'];
const EditRoster = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { addRosterFormData } = useWeeklyRosterContext();
  const start_date = searchParams.get('start_date') as string;
  const end_date = searchParams.get('end_date');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    const dataToServer = transformShifts(addRosterFormData, start_date);

    setLoading(true);
    try {
      const data = {
        roster: dataToServer
      };
      const res = await apiService.put('kitchen/rosters/departments/multiple', {
        data,
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(`${KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER}?start_date=${start_date}&end_date=${end_date}`);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <EditReviewHeader
        title={WEEKLY_ROSTER_PAGES.EDIT}
        start_date={start_date}
        end_date={end_date}
      />
      <div className='bg-[#FAFAFA] p-10'>
        <section>
          {addRosterFormData?.map((roster, idx) => (
            <div
              key={idx}
              className='mb-[6px] bg-white rounded-xl border-t border-x border-[#F5F5F5] pt-6 px-[30px]'>
              <h4 className='mb-3 text-base font-semibold text-red-6'>{roster.department}</h4>
              <div className='bg-[#F5F5F5] rounded-xl'>
                {shifts.map((shift, idx) => (
                  <EditKitchenShiftCard key={idx} shift={shift} dept={roster.department ?? ''} />
                ))}
              </div>
            </div>
          ))}
        </section>
        <EditReviewFooter
          end_date={end_date}
          start_date={start_date}
          onConfirm={handleConfirm}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default EditRoster;
